<div class="modal-header move-to-header">
  <p class="f-18">
    Move <b>"{{ source.title || source.detail }}"</b> To a Master Asset
  </p>
  <mtm-asset-list-actions
    [enableSort]="true"
    [enableExportAction]="false"
    [enableViewModeSwitching]="false"
    [enableTextSearch]="false"
    [campaignId]="campaignId"
    [isModal]="true"
    [assets]="assets"
    [selectedProjectIds]="selectedProjectIds"
    [selectedFocusValues]="selectedFocusValues"
    [selectedTypeValues]="selectedTypeValues"
    [selectedBetsValues]="selectedBetsValues"
    [selectedDurationValues]="selectedDurationValues"
    [selectedFormatValues]="selectedFormatValues"
    [selectedCategoriesValues]="selectedCategoriesValues"
    [selectedInUseValues]="selectedInUseValues"
    [selectedStatusValues]="selectedStatusValues"
    [selectedReleaseDateValues]="selectedReleaseDateValues"
    [showHiddenOnly]="showHiddenOnly"
    [currentSort]="currentSort"
    (selectedProjectIdsChange)="onSelectedProjectIdsChange($event)"
    (selectedFocusValuesChange)="onSelectedFocusValuesChange($event)"
    (selectedTypeValuesChange)="onSelectedTypeValuesChange($event)"
    (selectedBetsValuesChange)="onSelectedBetsValuesChange($event)"
    (selectedDurationValuesChange)="onSelectedDurationValuesChange($event)"
    (selectedFormatValuesChange)="onSelectedFormatValuesChange($event)"
    (selectedCategoriesValuesChange)="onSelectedCategoriesValuesChange($event)"
    (selectedInUseValuesChange)="onSelectedInUseValuesChange($event)"
    (selectedStatusValuesChange)="onSelectedStatusValuesChange($event)"
    (selectedReleaseDateValuesChange)="onSelectedReleaseDateValuesChange($event)"
    (showHiddenOnlyChange)="onShowHiddenOnlyChange($event)"
    (currentSortChange)="onCurrentSortChange($event)" />
</div>
<div class="modal-body move-to-body">
  <mtm-assets-table-view
    [bundle]="displayAssets"
    [originalBundle]="assets"
    [campaignId]="campaignId"
    [forSelection]="true"
    [isViewMode]="true"
    [currentSort]="currentSort"
    (rowSelectEvent)="onAssetSelect($event)" />
  <div
    *ngIf="selectedTargetAsset"
    class="move-to-body__info d-flex flex-column justify-content-center align-items-center text-center gap-2 px-5"
    appZoomScale>
    <h4 class="f-18"
      >You're about to convert <b>"{{ source.title || source.detail }}"</b> into a Technical Variant of
      <b>"{{ selectedTargetAsset.title || selectedTargetAsset.detail }}"</b>.<br />
      This action will change it status and link it under the selected Master.
    </h4>
    <h4 class="f-18">{{ 'move_to_proceed' | translate }}</h4>
  </div>
</div>
<div class="modal-footer move-to-footer">
  <button type="button" class="btn cancel-btn" (click)="onCancel()">
    <span class="cancel-btn-text">{{ 'cancel' | translate | uppercase }}</span>
  </button>
  <button type="button" class="btn save-btn" [disabled]="!selectedTargetAsset" (click)="onSave()">
    {{ 'YES' | translate }}
  </button>
</div>
